import authAxios from '@services/authAxios';

const fetchSystemType = async () => {
    const { data } = await authAxios({
        method: 'GET',
        url: `/api/v1/system-type/list`,
    });

    return data?.data;
};

export default fetchSystemType;
